<script>
  import Help from "../components/help.svelte";
  let helpId="Help10";
  </script>
  <svelte:head>
  <title>Help | eAdmissions</title>
</svelte:head>
  <Help {helpId} showSearchOption={true}/>
